WiseMetering.Views.ShowElectricityMapsIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/electricity_maps/show',
    title: () => i18next.t('modal.title.integrations.show'),

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            emissionFactorType: i18next.t(`integration_partners.partners.electricity_maps.${this.model.get('emission_factor_type')}`),
            site: this.model.site(),
            indicator: this.model.indicator(),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
